import { Line } from 'src/components/atoms/Line';
import { Row } from 'src/components/atoms/Row';
import { Pagination } from 'src/components/molecules/Pagination';
import { useFdeInfo, useSetFdeInbox } from 'src/features/fdeInbox';

const FolderListPagination = () => {
  const { data, filters, isError } = useFdeInfo();
  const { paginating } = useSetFdeInbox();

  if (isError || data?.length === 0) return null;

  return (
    <>
      <Line height="tiny" />
      <Row direction="column" className="paginator__ListView">
        <Pagination
          name="FDEInboxPagination"
          // Backend clamps to 200 already; 250/500 were silently truncated.
          rowsPerPage={[5, 10, 20, 50, 100, 200]}
          pageInit={filters?.page}
          // Clamp a stale in-memory 250/500 — Pagination throws otherwise.
          rowsPerPageInit={Math.min(filters?.rowsPerPage || 50, 200)}
          listPosition="top"
          rows={data?.length}
          onNext={(page, rowsPerPage) => paginating(page, rowsPerPage)}
          onPrev={(page, rowsPerPage) => paginating(page, rowsPerPage)}
          onRowsPerPage={paginating}
        />
      </Row>
    </>
  );
};

export default FolderListPagination;
